<template>
  <div>
    <b-row>
      <b-col>
        <b-table
          striped
          hover
          responsive
          :items="list"
          :fields="columns"
          :busy="isBusy"
          show-empty
          empty-text="No matching records found"
        >
          <template v-slot:cell(image_url)="data">
            <div
              class="d-flex justify-content-center"
              v-if="data.item.image_url"
            >
              <b-img
                class="box-image1-1"
                :src="data.item.image_url"
                fluid
                @error="handleImageSrc"
              ></b-img>
            </div>
            <div v-else class="d-flex justify-content-center">
              <b-img
                class="box-image1-1"
                src="/img/default-placeholder.png"
                fluid
              ></b-img>
            </div>
          </template>
          <template v-slot:cell(name)="data">
            <div class="text-left">
              <router-link :to="'/coupon/details/' + data.item.id">
                <b-button variant="link" class="name-link p-0">
                  {{ data.item.name }}
                </b-button>
              </router-link>
              <div class="line-clamp2 description">{{ data.item.detail }}</div>
              <div class="badge-container">
                <div
                  class="badge badge-secondary"
                  v-for="(coupon, index) in data.item.privilege_name"
                  :key="index"
                >
                  {{ coupon }}
                </div>
              </div>
            </div>
          </template>
          <template v-slot:cell(allow_customer_redeem)="{ item }">
            {{ item.allow_customer_redeem ? "By Customer" : "By Booth" }}
          </template>
          <template v-slot:cell(availability)="{ item }">
            {{ item.availability == 1 ? "Publish" : "Personalized" }}
          </template>
          <template v-slot:cell(max_quantity)="{ item }">
            {{ item.max_quantity == 0 ? "Unlimited" : item.max_quantity }}
          </template>
          <template v-slot:cell(validFrom)="data">
            <template
              v-if="
                data.item.validFrom == data.item.validTo &&
                data.item.valid_type_id == 2
              "
            >
              -
            </template>
            <template v-else>
              <div>{{ data.item.validFrom | moment($formatDateNew) }}</div>
              <div class="time-color">
                {{ data.item.validFrom | moment("HH:mm:ss") }}
              </div>
            </template>
          </template>
          <template v-slot:cell(validTo)="data">
            <template
              v-if="
                data.item.validFrom == data.item.validTo &&
                data.item.valid_type_id == 2
              "
            >
              -
            </template>
            <template v-else>
              <div>{{ data.item.validTo | moment($formatDateNew) }}</div>
              <div class="time-color">
                {{ data.item.validTo | moment("HH:mm:ss") }}
              </div>
            </template>
          </template>
          <template v-slot:cell(status)="data">
            <div class="d-flex justify-content-center">
              <span class="text-success" v-if="data.item.status === 1"
                >Active</span
              >
              <span class="text-error" v-if="data.item.status === 0"
                >Inactive</span
              >
            </div>
          </template>
          <template v-slot:table-busy>
            <div class="text-center text-black my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong class="ml-2">Loading...</strong>
            </div>
          </template>
        </b-table>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      required: true,
      type: Array,
    },
    columns: {
      required: true,
      type: Array,
    },
    isBusy: {
      required: false,
      type: Boolean,
    },
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
::v-deep thead {
  background-color: #f0b6c7;
  color: var(--font-color);
}
.time {
  color: #afafaf;
}
.line-clamp2 {
  word-break: break-word;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.badge {
  font-size: 85%;
  background-color: var(--theme-secondary-color);
  color: var(--primary-color);
  font-weight: 100;

  max-width: max-content;
}
.description {
  color: #b1b1b1;
}
.badge-container {
  display: flex;
  flex-direction: column;
  gap: 5px;
}
</style>
